export default "__VITE_ASSET__jShCWJyR__"